<template>
  <div>
    <page-title-bar :customTitle="customTitle"></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-toolbar :elevation="0" height="auto">
            <v-layout row justify-end align-center>
              <v-flex xs12 md4>
                <v-layout row class="ma-0 py-2">
                  <div>
                    <v-flex class="py-1">Số dư đầu kỳ</v-flex>
                    <v-flex class="py-1">Tổng thu</v-flex>
                    <v-flex class="py-1">Tổng chi</v-flex>
                    <v-flex class="py-1">Số dư cuối kỳ</v-flex>
                  </div>
                  <div>
                    <v-flex class="py-1 text-right">{{
                      this.opening_balance | formatCurrency
                      }}</v-flex>
                    <v-flex class="py-1 text-right">{{
                      this.total_income | formatCurrency
                      }}</v-flex>
                    <v-flex class="py-1 text-right">{{
                      this.total_expense | formatCurrency
                      }}</v-flex>
                    <v-flex class="py-1 text-right">
                      {{
                        (this.opening_balance + this.accumulated_balance)
                        | formatCurrency
                      }}
                    </v-flex>
                  </div>
                </v-layout>
              </v-flex>
              <v-flex row xs12 md8>
                <v-layout row justify-space-between align-center>
                  <v-flex xs12 md4>
                    <v-select label="Tài khoản" :disabled="loader" v-model="chosen_wallet_account_id"
                      :items="list_wallet_account" item-text="name" item-value="id"
                      prepend-icon="account_balance_wallet" required hide-details></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-menu :close-on-content-click="false" v-model="menu_date_start" :nudge-right="40" lazy
                      transition="scale-transition" offset-y full-width min-width="290px">
                      <v-text-field slot="activator" v-model="date_start" label="Ngày bắt đầu" :disabled="loader"
                        prepend-icon="event" readonly hide-details></v-text-field>
                      <v-date-picker locale="vi-VI" v-model="date_start"
                        @input="menu_date_start = false"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-menu :close-on-content-click="false" v-model="menu_date_end" :nudge-right="40" lazy
                      transition="scale-transition" offset-y full-width min-width="290px" hide-details>
                      <v-text-field slot="activator" v-model="date_end" label="Ngày kết thúc" :disabled="loader"
                        prepend-icon="event" readonly hide-details></v-text-field>
                      <v-date-picker locale="vi-VI" v-model="date_end" @input="menu_date_end = false"></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout row justify-space-between align-center>
                  <v-flex shrink>
                    <div class="text-right">
                      <v-btn :disabled="loader" @click="print_table = true" color="primary">
                        <v-icon small left>print</v-icon>
                        IN SỔ TIỀN MẶT
                      </v-btn>
                      <v-btn :loader="loader || export_csv.loader" @click="exportCSV" color="green" dark>XUẤT
                        EXCEL</v-btn>
                      <export-csv-button :trigger="export_csv.trigger" :title="export_csv.title"
                        :rows="export_csv.rows"></export-csv-button>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-toolbar>
          <div class="mt-3">
            <v-layout row wrap>
              <v-flex xs12 md12>
                <div class="d-flex justify-space-between align-center pa-2">
                  <div v-if="!loader">
                    <v-chip disabled color="green" text-color="white">Số phiếu đã chọn: {{ selected.length }}</v-chip>
                    <v-chip disabled color="blue" text-color="white">Tổng số tiền: {{ selected_receipts_total_amount |
                      formatNumber}} VND</v-chip>
                  </div>
                  <v-btn @click="dialog_receipt_cash = !dialog_receipt_cash" color="green" style="max-width: 250px;" :disabled="selected_receipts_total_amount === 0">
                    <v-icon small class="mr-1">add_box</v-icon>Tạo phiếu thu tiền mặt
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
            <v-card>
              <v-data-table v-model="selected" disable-initial-sort :headers="headers" :items="items" select-all
                item-key="_id" class="elevation-1" :rows-per-page-items="rowPerPage">
                <template v-slot:headers="props">
                  <tr>
                    <th>
                      <v-checkbox class="justify-center" :input-value="props.all" :indeterminate="props.indeterminate"
                        primary hide-details @click.stop="toggleAll" :disabled="loader"></v-checkbox>
                    </th>
                    <th v-for="header in props.headers" :key="header.text">
                      <span style="padding-right: 16px">{{ header.text }}</span>
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr :active="props.selected" @click="props.selected = !(props.item.type === 'receipt_cash' || props.item.receipt_cash_id) ? !props.selected : false">
                    <td>
                      <v-checkbox class="justify-center" :disabled="loader" :input-value="props.selected" primary v-if="!(props.item.type === 'receipt_cash' || props.item.receipt_cash_id)"
                        hide-details></v-checkbox>
                        <v-menu offset-y v-if="props.item.type === 'receipt_cash'">
                            <v-btn icon slot="activator">
                                <v-icon small color="#464D69">settings</v-icon>
                            </v-btn>
                            <v-list>
                                <v-list-tile
                                    @click="selectReceiptCashToReview(props.item)"
                                >
                                    <v-list-tile-title>
                                        Xem chi tiết
                                    </v-list-tile-title>
                                </v-list-tile>
                            
                            </v-list>
                        </v-menu>
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.index + 1 }}
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.item.receipt_id }}
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.item.date_action | formatTimeServer }}
                    </td>
                    <td class="text-right text-no-wrap" @click.stop>
                      {{ props.item.collected_amount || props.item.deposit_amount | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap" @click.stop>
                      {{ props.item.amount | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap" @click.stop>
                      {{ props.item.balance | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap" @click.stop>
                      {{ props.item.accumulated_balance | formatCurrency }}
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.item.note }}
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.item.room_id }}
                    </td>
                  </tr>
                </template>
                <template #no-data>
                  Chưa có thông tin
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <print-portal layout="portrait" :open="print_table" @close="print_table = false">
      <print-so-tien-mat :items="items"></print-so-tien-mat>
    </print-portal>
    <dialog-tao-phieu-thu-tien-mat
      :dialog="dialog_receipt_cash"
      @changeDialogState="dialog_receipt_cash = $event"
      @resetTable="resetTable()"
      :chosen_wallet_account_id="chosen_wallet_account_id"
      :list_receipts="selected.slice()"
      :collected_amount="selected_receipts_total_amount"
    >
    </dialog-tao-phieu-thu-tien-mat>
    <dialog-tao-phieu-thu-tien-mat
      :dialog="dialog_review_receipt_cash"
      @changeDialogState="dialog_review_receipt_cash = $event"
      @resetTable="resetTable()"
      :chosen_wallet_account_id="chosen_wallet_account_id"
      :list_receipts="selected_receipt_cash_to_review.list_receipts"
      :collected_amount="selected_receipt_cash_to_review.amount"
      :is_review_only="true"
      :review_receipt="selected_receipt_cash_to_review"
    >
    </dialog-tao-phieu-thu-tien-mat>
  </div>
</template>

<script>
import moment from "moment";
import api from "Api";
import ExportCsvButton from "Components/ExportExcel/ExportCsvButton.vue";
import PrintPortal from "Components/Print/PrintPortal";
import PrintSoTienMat from "Components/Print/PrintSoTienMat";
import {
  EXPENSE_ACCOUNT_TYPE_LIST,
  INCOME_ACCOUNT_TYPE_LIST,
  EXPENSE_ACCOUNT_OPTIONS,
} from "Constants/db-config.js";
import { formatTimeServer, translateWalletName } from "Helpers";
import { buildParamQuery } from "Helpers";
import DialogTaoPhieuThuTienMat from "../../components/Phieu/DialogTaoPhieuThuTienMat.vue";

export default {
  name: "so-tien-mat",
  components: {
    ExportCsvButton,
    PrintPortal,
    PrintSoTienMat,
    DialogTaoPhieuThuTienMat,
  },
  data() {
    return {
      loader: false,
      headers: [
        {
          text: "Số thứ tự",
          align: "center",
          sortable: false,
          value: "index",
        },
        {
          text: "Số chứng từ",
          align: "center",
          sortable: true,
          value: "receipt_id",
        },
        {
          text: "Ngày",
          align: "center",
          sortable: true,
          value: "date_action",
        },
        {
          text: "Số tiền thu",
          align: "center",
          sortable: true,
          value: "collected_amount",
        },
        {
          text: "Số tiền chi",
          align: "center",
          sortable: true,
          value: "amount",
        },
        {
          text: "Số dư",
          align: "center",
          sortable: true,
          value: "balance",
        },
        {
          text: "Số dư cộng dồn",
          align: "center",
          sortable: true,
          value: "accumulated_balance",
        },
        {
          text: "Nội dung chi tiết",
          align: "center",
          sortable: true,
          value: "note",
        },
        {
          text: "Số phòng",
          align: "center",
          sortable: true,
          value: "room_id",
        },
      ],
      export_csv: {
        loader: false,
        trigger: false,
        title: "",
        rows: [],
      },
      items: [],
      print_table: false,
      rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
      menu_date_start: false,
      menu_date_end: false,
      date_start: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      date_end: new Date().toISOString().substring(0, 10),
      accumulated_balance: 0,
      chosen_wallet_account_id: 6,
      opening_balance: 0,
      total_income: 0,
      total_expense: 0,
      selected: [],
      dialog_receipt_cash: false,
      selected_receipts_total_amount: 0,
      dialog_review_receipt_cash: false,
      selected_receipt_cash_to_review: {
        amount: 0,
        list_receipts: [],
      },
      EXPENSE_ACCOUNT_OPTIONS,
    };
  },
  watch: {
    date_start: function () {
      this.getData();
    },
    date_end: function () {
      this.getData();
    },
    chosen_wallet_account_id: function () {
      this.getData();
    },
    list_wallet_account: function (nv) {
      if (!this.chosen_wallet_account_id) {
        this.chosen_wallet_account_id = nv[0].id;
      }
    },
    selected: function (nv) {
      this.selected_receipts_total_amount = this.calcTotalAmount(nv)
    },
    dialog_review_receipt_cash: function (nv) {
      if (!nv) {
        this.selected_receipt_cash_to_review = {
          amount: 0,
          list_receipts: [],
        };
      }
    },
  },

  mounted() {
    if (this.list_wallet_account.length) {
      this.chosen_wallet_account_id = 6;
      this.getData();
    }
  },
  created() { },
  computed: {
    customTitle() {
      return "Sổ " + translateWalletName(this.chosen_wallet_account_id);
    },
    list_wallet_account() {
      return (
        (this.$store.state.app.wallets &&
          this.$store.state.app.wallets.filter(
            (item) => item.name && item.name.toLowerCase().includes("tiền mặt") && item.name !== 'Tiền mặt'
          )) ||
        []
      );
    },
  },
  methods: {
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.items.filter((item) => !(item.type === 'receipt_cash' || item.receipt_cash_id));
    },
    resetTable: function () {
      this.selected = [],
      this.getData();
    },
    selectReceiptCashToReview: function (receipt) {
      this.selected_receipt_cash_to_review = receipt;
      this.selected_receipt_cash_to_review.list_receipts = this.selected_receipt_cash_to_review.list_receipts.map((item) => {
          let balance = 0;
          
          const filterExpenseOptions = this.EXPENSE_ACCOUNT_OPTIONS.filter(
            (item) => item.text !== "Chi lương (cũ)"
          );

          if (INCOME_ACCOUNT_TYPE_LIST.includes(item.type)) {
            balance = item.collected_amount;

            if (item.type === 'receipt_room') {
              item.note = `Thu tiền phòng ${item.room_id || ''}`;
            } else if (item.type === 'deposit_revenue') {
              item.note = `Thu tiền cọc lần ${item.deposit_type || ''} ${item.room_id || ''}`;
            } else {
              item.note = `Thu khác ${item.note || ''}`

            }

          } else if (EXPENSE_ACCOUNT_TYPE_LIST.includes(item.type) || item.type === 'receipt_cash') {
            balance = -item.amount;

            if (item.type === 'receipt_cash') {
              item.note = `Thu tiền mặt ${item.note || ''}`
            } else {
              const foundExpenseOption = filterExpenseOptions.find(
                (option) => option.value === item.type
              );

              item.note = `${foundExpenseOption.text} ${item.room_id || item.note || ''}`
            }
          }

          return {
            ...item,
            date_action: item.date_collected || item.date_created || item.date_deposit,
            balance,
          };
        });
      this.dialog_review_receipt_cash = true;
    },
    getData: async function () {
      this.loader = true;

      const params = {
        dateStart: this.date_start,
        dateEnd: this.date_end,
        walletAccountId: this.chosen_wallet_account_id,
      };
      const query = buildParamQuery(params);
      const results = await Promise.all([
        api.getReceiptRoomAndOther(query),
        api.getDepositReceipts(query),
        api.getDisbursementReceipt(query),
        api.findReceiptCash(query),
      ]);

      this.items = [];

      this.total_income = 0;

      this.total_expense = 0;

      this.accumulated_balance = 0;

      this.items = results
        .reduce((acc, result) => {
          return acc.concat(result.data);
        }, [])
        .sort((a, b) => {
          const a_date_action = a.date_collected || a.date_created || a.date_deposit;

          const b_date_action = b.date_collected || b.date_created || a.date_deposit;

          return new Date(a_date_action) - new Date(b_date_action);
        })
        .map((item) => {
          let balance = 0;
          const filterExpenseOptions = this.EXPENSE_ACCOUNT_OPTIONS.filter(
            (item) => item.text !== "Chi lương (cũ)"
          );

          if (INCOME_ACCOUNT_TYPE_LIST.includes(item.type)) {
            balance = item.collected_amount || item.deposit_amount;

            this.total_income += balance;

            if (item.type === 'receipt_room') {
              item.note = `Thu tiền phòng ${item.room_id || ''}`;
            } else if (item.type === 'deposit_revenue') {
              item.note = `Thu tiền cọc lần ${item.deposit_type || ''} ${item.room_id || ''}`;
            } else {
               item.note = `Thu khác ${item.note || ''}`
            }

          } else if (EXPENSE_ACCOUNT_TYPE_LIST.includes(item.type) || item.type === 'receipt_cash') {
            balance = -item.amount;

            this.total_expense += item.amount;

            if (item.type === 'receipt_cash') {
              item.note = `Thu tiền mặt ${item.note || ''}`
            } else {
              const foundExpenseOption = filterExpenseOptions.find(
                (option) => option.value === item.type
              );

              item.note = `${foundExpenseOption.text} ${item.room_id || item.note || ''}`
            }
          }

          this.accumulated_balance += balance;

          return {
            ...item,
            date_action: item.date_collected || item.date_created || item.date_deposit,
            balance,
            accumulated_balance: this.accumulated_balance,
          };
        });

      this.loader = false;
    },
    exportCSV: function () {
      const rows = this.items.map((item, index) => {
        const row = {};
        for (let field of this.headers) {
          if (field.text === "Số tiền thu") {
            row[field.text] = item.collected_amount || item.deposit_amount;
          } else {
            row[field.text] = item[field.value];
          }
        }
        return { ...row, "Số thứ tự": index + 1 };
      });

      this.export_csv.rows = rows;
      this.export_csv.title = `SoTienMat_${this.date_start}_${this.date_end}`;
      this.export_csv.trigger = !this.export_csv.trigger;
    },
    calcTotalAmount: arr =>
      arr.reduce(
        (accumulator, currentReceipt) => {
          let balance = 0;

          if (INCOME_ACCOUNT_TYPE_LIST.includes(currentReceipt.type)) {
            balance = currentReceipt.collected_amount || currentReceipt.deposit_amount;
          } else if (EXPENSE_ACCOUNT_TYPE_LIST.includes(currentReceipt.type)) {
            balance = -currentReceipt.amount;
          }

          accumulator += balance;

          return accumulator;
        },
        0
      ),
  },
};
</script>
